import { RootState } from '../index';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { formatApprovalProjects } from './utils';
import { selectCurrencyArray } from '../currency/selectors';

const approvalProjects = (state: RootState) => state.approval.projects;
const loading = (state: RootState) => state.approval.loading;

const selectedProjectId = (state: RootState) =>
  state.approval.selectedProjectId;

export const selectApprovalProjects = createDraftSafeSelector(
  [approvalProjects, selectCurrencyArray],
  (projects, currencies) => formatApprovalProjects(projects || [], currencies),
);

export const selectApprovalLoading = createDraftSafeSelector(
  loading,
  (loading) => loading,
);

export const selectSelectedProject = createDraftSafeSelector(
  [approvalProjects, selectedProjectId],
  (projects, selectedId) => {
    return projects.find((project) => project.id === selectedId);
  },
);
